function initializeSlider() {
  var $slider = $('.col--desktop-slider');
  var columnCount = parseInt($slider.attr('data-column'), 10) || 4;
  var columnmobileCount = parseInt($slider.attr('data-mobile-column'), 10) || 1;

  // Destroy slider if it's already initialized
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    infinite: false,
    slidesToShow: columnCount,
    slidesToScroll: 1,
    prevArrow: '<div class="slick-prev"><svg class="icon--icon-prev" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="m4 10l9 9l1.4-1.5L7 10l7.4-7.5L13 1z"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg class="icon--icon-next"  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="M7 1L5.6 2.5L13 10l-7.4 7.5L7 19l9-9z"/></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: columnmobileCount,
          slidesToScroll: 1
        }
      }
    ]
  });
}

$(document).ready(function() {
  setTimeout(function() {
  initializeSlider();
}, 500);
  // Reinitialize on section load or block select inside the theme editor
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initializeSlider();
    });

    document.addEventListener('shopify:section:select', function() {
      initializeSlider();
    });

    document.addEventListener('shopify:block:select', function() {
      initializeSlider();
    });
  }
});
